export default __webpack_public_path__ + "static/media/revere-plastics.66a08fb0.png";